import {TalepTur} from './talep-tur';
import {KullaniciGrup} from './kullanici-grup';

export class TalepOnaySeviye {

  id: number;
  seviye: number;
  talepTurId: number;
  kullaniciGrupId: number;
  talepTur: TalepTur;
  kullaniciGrup: KullaniciGrup;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.talepTur != null) {
      this.talepTur = new TalepTur(obj.talepTur);
    }
    if (obj.kullaniciGrup != null) {
      this.kullaniciGrup = new KullaniciGrup(obj.kullaniciGrup);
    }
  }

}
